import React from "react";
const ErrorIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "210",
    height: "162",
    viewBox: "0 0 210 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6346_14586)" }, /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "mask0_6346_14586",
      style: { maskType: "alpha" },
      maskUnits: "userSpaceOnUse",
      x: "48",
      y: "0",
      width: "162",
      height: "162"
    },
    /* @__PURE__ */ React.createElement("path", { d: "M48 0H210V162H48V0Z", fill: "url(#paint0_linear_6346_14586)" })
  ), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_6346_14586)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M48 6.5C48 2.91015 50.9101 0 54.5 0H203.5C207.09 0 210 2.91015 210 6.5C210 10.0899 207.09 13 203.5 13H54.5C50.9102 13 48 10.0899 48 6.5Z",
      fill: "url(#paint1_linear_6346_14586)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M48 35.5C48 31.9101 50.9101 29 54.5 29H161.5C165.09 29 168 31.9101 168 35.5C168 39.0899 165.09 42 161.5 42H54.5C50.9102 42 48 39.0899 48 35.5Z",
      fill: "url(#paint2_linear_6346_14586)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M48 64.5C48 60.9101 50.9101 58 54.5 58H203.5C207.09 58 210 60.9101 210 64.5C210 68.0899 207.09 71 203.5 71H54.5C50.9102 71 48 68.0899 48 64.5Z",
      fill: "url(#paint3_linear_6346_14586)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M202.507 58V58.5H203.5C203.766 58.5 204.028 58.5173 204.284 58.5508L204.348 58.0566C205.508 58.2078 206.572 58.6642 207.456 59.3438L207.152 59.7393C207.568 60.0588 207.941 60.4318 208.261 60.8477L208.655 60.543C209.335 61.4273 209.791 62.491 209.942 63.6514L209.449 63.7158C209.483 63.9723 209.5 64.234 209.5 64.5C209.5 64.766 209.483 65.0277 209.449 65.2842L209.942 65.3477C209.791 66.5082 209.335 67.5716 208.655 68.4561L208.261 68.1523C207.941 68.5682 207.568 68.9412 207.152 69.2607L207.456 69.6553C206.572 70.335 205.508 70.7912 204.348 70.9424L204.284 70.4492C204.028 70.4827 203.766 70.5 203.5 70.5H202.507V71H198.533V70.5H196.547V71H192.573V70.5H190.587V71H186.613V70.5H184.627V71H180.653V70.5H178.667V71H174.693V70.5H172.707V71H168.733V70.5H166.747V71H162.773V70.5H160.787V71H156.813V70.5H154.827V71H150.854V70.5H148.866V71H144.894V70.5H142.906V71H138.934V70.5H136.946V71H132.974V70.5H130.986V71H127.014V70.5H125.026V71H121.054V70.5H119.066V71H115.094V70.5H113.106V71H109.134V70.5H107.146V71H103.174V70.5H101.187V71H97.2129V70.5H95.2266V71H91.2529V70.5H89.2666V71H85.293V70.5H83.3066V71H79.333V70.5H77.3467V71H73.373V70.5H71.3867V71H67.4131V70.5H65.4268V71H61.4531V70.5H59.4668V71H55.4932V70.5H54.5C54.234 70.5 53.9723 70.4827 53.7158 70.4492L53.6514 70.9424C52.491 70.791 51.4273 70.3351 50.543 69.6553L50.8477 69.2607C50.4318 68.9412 50.0588 68.5682 49.7393 68.1523L49.3438 68.4561C48.6642 67.5716 48.2078 66.508 48.0566 65.3477L48.5508 65.2842C48.5173 65.0277 48.5 64.766 48.5 64.5C48.5 64.234 48.5173 63.9723 48.5508 63.7158L48.0566 63.6514C48.208 62.4911 48.6641 61.4273 49.3438 60.543L49.7393 60.8477C50.0588 60.4318 50.4318 60.0588 50.8477 59.7393L50.543 59.3438C51.4273 58.6641 52.4911 58.208 53.6514 58.0566L53.7158 58.5508C53.9723 58.5173 54.234 58.5 54.5 58.5H55.4932V58H59.4668V58.5H61.4531V58H65.4268V58.5H67.4131V58H71.3867V58.5H73.373V58H77.3467V58.5H79.333V58H83.3066V58.5H85.293V58H89.2666V58.5H91.2529V58H95.2266V58.5H97.2129V58H101.187V58.5H103.173V58H107.146V58.5H109.134V58H113.106V58.5H115.094V58H119.066V58.5H121.054V58H125.026V58.5H127.014V58H130.986V58.5H132.974V58H136.946V58.5H138.934V58H142.906V58.5H144.894V58H148.866V58.5H150.854V58H154.826V58.5H156.813V58H160.787V58.5H162.773V58H166.747V58.5H168.733V58H172.707V58.5H174.693V58H178.667V58.5H180.653V58H184.627V58.5H186.613V58H190.587V58.5H192.573V58H196.547V58.5H198.533V58H202.507Z",
      stroke: "#E62214",
      strokeOpacity: "0.25",
      strokeDasharray: "2 4"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M48 93.5C48 89.9101 50.9101 87 54.5 87H161.5C165.09 87 168 89.9101 168 93.5C168 97.0899 165.09 100 161.5 100H54.5C50.9102 100 48 97.0899 48 93.5Z",
      fill: "url(#paint4_linear_6346_14586)",
      fillOpacity: "0.75"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M160.509 87V87.5H161.5C161.766 87.5 162.028 87.5173 162.284 87.5508L162.348 87.0566C163.508 87.2078 164.572 87.6642 165.456 88.3438L165.152 88.7393C165.568 89.0588 165.941 89.4318 166.261 89.8477L166.655 89.543C167.335 90.4273 167.791 91.491 167.942 92.6514L167.449 92.7158C167.483 92.9723 167.5 93.234 167.5 93.5C167.5 93.766 167.483 94.0277 167.449 94.2842L167.942 94.3477C167.791 95.5082 167.335 96.5716 166.655 97.4561L166.261 97.1523C165.941 97.5682 165.568 97.9412 165.152 98.2607L165.456 98.6553C164.572 99.335 163.508 99.7912 162.348 99.9424L162.284 99.4492C162.028 99.4827 161.766 99.5 161.5 99.5H160.509V100H156.546V99.5H154.564V100H150.602V99.5H148.62V100H144.657V99.5H142.676V100H138.713V99.5H136.731V100H132.769V99.5H130.787V100H126.824V99.5H124.843V100H120.88V99.5H118.898V100H114.936V99.5H112.954V100H108.991V99.5H107.009V100H103.046V99.5H101.064V100H97.1016V99.5H95.1201V100H91.1572V99.5H89.1758V100H85.2129V99.5H83.2314V100H79.2686V99.5H77.2871V100H73.3242V99.5H71.3428V100H67.3799V99.5H65.3984V100H61.4355V99.5H59.4541V100H55.4912V99.5H54.5C54.234 99.5 53.9723 99.4827 53.7158 99.4492L53.6514 99.9424C52.491 99.791 51.4273 99.3351 50.543 98.6553L50.8477 98.2607C50.4318 97.9412 50.0588 97.5682 49.7393 97.1523L49.3438 97.4561C48.6642 96.5716 48.2078 95.508 48.0566 94.3477L48.5508 94.2842C48.5173 94.0277 48.5 93.766 48.5 93.5C48.5 93.234 48.5173 92.9723 48.5508 92.7158L48.0566 92.6514C48.208 91.4911 48.6641 90.4273 49.3438 89.543L49.7393 89.8477C50.0588 89.4318 50.4318 89.0588 50.8477 88.7393L50.543 88.3438C51.4273 87.6641 52.4911 87.208 53.6514 87.0566L53.7158 87.5508C53.9723 87.5173 54.234 87.5 54.5 87.5H55.4912V87H59.4541V87.5H61.4355V87H65.3984V87.5H67.3799V87H71.3428V87.5H73.3242V87H77.2871V87.5H79.2686V87H83.2314V87.5H85.2129V87H89.1758V87.5H91.1572V87H95.1201V87.5H97.1016V87H101.064V87.5H103.046V87H107.009V87.5H108.991V87H112.954V87.5H114.936V87H118.898V87.5H120.88V87H124.843V87.5H126.824V87H130.787V87.5H132.769V87H136.731V87.5H138.713V87H142.676V87.5H144.657V87H148.62V87.5H150.602V87H154.564V87.5H156.546V87H160.509Z",
      stroke: "#E62214",
      strokeOpacity: "0.5",
      strokeDasharray: "2 4"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M182.352 92.6041L176 89.7881V91.2441L181.232 93.4681L176 95.6921V97.2121L182.352 94.3801V92.6041Z",
      fill: "#A8CAFF"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M48 122.5C48 118.91 50.9101 116 54.5 116H203.5C207.09 116 210 118.91 210 122.5C210 126.09 207.09 129 203.5 129H54.5C50.9102 129 48 126.09 48 122.5Z",
      fill: "url(#paint5_linear_6346_14586)",
      fillOpacity: "0.5"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M202.507 116V116.5H203.5C203.766 116.5 204.028 116.517 204.284 116.551L204.348 116.057C205.508 116.208 206.572 116.664 207.456 117.344L207.152 117.739C207.568 118.059 207.941 118.432 208.261 118.848L208.655 118.543C209.335 119.427 209.791 120.491 209.942 121.651L209.449 121.716C209.483 121.972 209.5 122.234 209.5 122.5C209.5 122.766 209.483 123.028 209.449 123.284L209.942 123.348C209.791 124.508 209.335 125.572 208.655 126.456L208.261 126.152C207.941 126.568 207.568 126.941 207.152 127.261L207.456 127.655C206.572 128.335 205.508 128.791 204.348 128.942L204.284 128.449C204.028 128.483 203.766 128.5 203.5 128.5H202.507V129H198.533V128.5H196.547V129H192.573V128.5H190.587V129H186.613V128.5H184.627V129H180.653V128.5H178.667V129H174.693V128.5H172.707V129H168.733V128.5H166.747V129H162.773V128.5H160.787V129H156.813V128.5H154.827V129H150.854V128.5H148.866V129H144.894V128.5H142.906V129H138.934V128.5H136.946V129H132.974V128.5H130.986V129H127.014V128.5H125.026V129H121.054V128.5H119.066V129H115.094V128.5H113.106V129H109.134V128.5H107.146V129H103.174V128.5H101.187V129H97.2129V128.5H95.2266V129H91.2529V128.5H89.2666V129H85.293V128.5H83.3066V129H79.333V128.5H77.3467V129H73.373V128.5H71.3867V129H67.4131V128.5H65.4268V129H61.4531V128.5H59.4668V129H55.4932V128.5H54.5C54.234 128.5 53.9723 128.483 53.7158 128.449L53.6514 128.942C52.491 128.791 51.4273 128.335 50.543 127.655L50.8477 127.261C50.4318 126.941 50.0588 126.568 49.7393 126.152L49.3438 126.456C48.6642 125.572 48.2078 124.508 48.0566 123.348L48.5508 123.284C48.5173 123.028 48.5 122.766 48.5 122.5C48.5 122.234 48.5173 121.972 48.5508 121.716L48.0566 121.651C48.208 120.491 48.6641 119.427 49.3438 118.543L49.7393 118.848C50.0588 118.432 50.4318 118.059 50.8477 117.739L50.543 117.344C51.4273 116.664 52.4911 116.208 53.6514 116.057L53.7158 116.551C53.9723 116.517 54.234 116.5 54.5 116.5H55.4932V116H59.4668V116.5H61.4531V116H65.4268V116.5H67.4131V116H71.3867V116.5H73.373V116H77.3467V116.5H79.333V116H83.3066V116.5H85.293V116H89.2666V116.5H91.2529V116H95.2266V116.5H97.2129V116H101.187V116.5H103.173V116H107.146V116.5H109.134V116H113.106V116.5H115.094V116H119.066V116.5H121.054V116H125.026V116.5H127.014V116H130.986V116.5H132.974V116H136.946V116.5H138.934V116H142.906V116.5H144.894V116H148.866V116.5H150.854V116H154.826V116.5H156.813V116H160.787V116.5H162.773V116H166.747V116.5H168.733V116H172.707V116.5H174.693V116H178.667V116.5H180.653V116H184.627V116.5H186.613V116H190.587V116.5H192.573V116H196.547V116.5H198.533V116H202.507Z",
      stroke: "#E62214",
      strokeOpacity: "0.75",
      strokeDasharray: "2 4"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M160.509 145V145.5H161.5C161.766 145.5 162.028 145.517 162.284 145.551L162.348 145.057C163.508 145.208 164.572 145.664 165.456 146.344L165.152 146.739C165.568 147.059 165.941 147.432 166.261 147.848L166.655 147.543C167.335 148.427 167.791 149.491 167.942 150.651L167.449 150.716C167.483 150.972 167.5 151.234 167.5 151.5C167.5 151.766 167.483 152.028 167.449 152.284L167.942 152.348C167.791 153.508 167.335 154.572 166.655 155.456L166.261 155.152C165.941 155.568 165.568 155.941 165.152 156.261L165.456 156.655C164.572 157.335 163.508 157.791 162.348 157.942L162.284 157.449C162.028 157.483 161.766 157.5 161.5 157.5H160.509V158H156.546V157.5H154.564V158H150.602V157.5H148.62V158H144.657V157.5H142.676V158H138.713V157.5H136.731V158H132.769V157.5H130.787V158H126.824V157.5H124.843V158H120.88V157.5H118.898V158H114.936V157.5H112.954V158H108.991V157.5H107.009V158H103.046V157.5H101.064V158H97.1016V157.5H95.1201V158H91.1572V157.5H89.1758V158H85.2129V157.5H83.2314V158H79.2686V157.5H77.2871V158H73.3242V157.5H71.3428V158H67.3799V157.5H65.3984V158H61.4355V157.5H59.4541V158H55.4912V157.5H54.5C54.234 157.5 53.9723 157.483 53.7158 157.449L53.6514 157.942C52.491 157.791 51.4273 157.335 50.543 156.655L50.8477 156.261C50.4318 155.941 50.0588 155.568 49.7393 155.152L49.3438 155.456C48.6642 154.572 48.2078 153.508 48.0566 152.348L48.5508 152.284C48.5173 152.028 48.5 151.766 48.5 151.5C48.5 151.234 48.5173 150.972 48.5508 150.716L48.0566 150.651C48.208 149.491 48.6641 148.427 49.3438 147.543L49.7393 147.848C50.0588 147.432 50.4318 147.059 50.8477 146.739L50.543 146.344C51.4273 145.664 52.4911 145.208 53.6514 145.057L53.7158 145.551C53.9723 145.517 54.234 145.5 54.5 145.5H55.4912V145H59.4541V145.5H61.4355V145H65.3984V145.5H67.3799V145H71.3428V145.5H73.3242V145H77.2871V145.5H79.2686V145H83.2314V145.5H85.2129V145H89.1758V145.5H91.1572V145H95.1201V145.5H97.1016V145H101.064V145.5H103.046V145H107.009V145.5H108.991V145H112.954V145.5H114.936V145H118.898V145.5H120.88V145H124.843V145.5H126.824V145H130.787V145.5H132.769V145H136.731V145.5H138.713V145H142.676V145.5H144.657V145H148.62V145.5H150.602V145H154.564V145.5H156.546V145H160.509Z",
      fill: "url(#paint6_linear_6346_14586)",
      stroke: "#E62214",
      strokeDasharray: "2 4"
    }
  ))),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0 147C0 138.716 6.71573 132 15 132C23.2843 132 30 138.716 30 147C30 155.284 23.2843 162 15 162C6.71573 162 0 155.284 0 147Z",
      fill: "url(#paint7_linear_6346_14586)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.7037 141.962L21.7093 149.959C21.9071 150.285 22.0008 150.645 22 151C21.9984 151.674 21.6561 152.331 21.0377 152.707C20.7248 152.897 20.3658 152.997 19.9997 152.997L10 153C8.89543 153 8 152.105 8 151C8 150.634 8.10046 150.275 8.29042 149.962L13.2846 141.962C13.6616 141.341 14.3229 140.999 15 141C15.3523 141.001 15.709 141.095 16.0321 141.291C16.3067 141.457 16.5371 141.688 16.7037 141.962ZM15 144C14.4477 144 14 144.448 14 145V147C14 147.552 14.4477 148 15 148C15.5523 148 16 147.552 16 147V145C16 144.448 15.5523 144 15 144ZM15 149C14.4477 149 14 149.448 14 150C14 150.552 14.4477 151 15 151C15.5523 151 16 150.552 16 150C16 149.448 15.5523 149 15 149Z",
      fill: "#E62214"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "mask1_6346_14586",
      style: { maskType: "alpha" },
      maskUnits: "userSpaceOnUse",
      x: "14",
      y: "0",
      width: "2",
      height: "124"
    },
    /* @__PURE__ */ React.createElement("path", { d: "M14 0H16V124H14V0Z", fill: "url(#paint8_linear_6346_14586)" })
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#mask1_6346_14586)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14 0.999999C14 0.447714 14.4477 0 15 0C15.5523 0 16 0.447715 16 1V123C16 123.552 15.5523 124 15 124C14.4477 124 14 123.552 14 123V0.999999Z",
      fill: "url(#paint9_linear_6346_14586)"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint0_linear_6346_14586",
      x1: "129",
      y1: "162",
      x2: "129",
      y2: "0",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { offset: "0.495192", stopColor: "#F6F7F9" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#F6F7F9", stopOpacity: "0" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint1_linear_6346_14586",
      x1: "48",
      y1: "6.50001",
      x2: "210",
      y2: "6.50001",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#D6E6FE" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#E7F0FF" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint2_linear_6346_14586",
      x1: "48",
      y1: "35.5",
      x2: "168",
      y2: "35.5",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#D6E6FE" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#E7F0FF" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint3_linear_6346_14586",
      x1: "48",
      y1: "64.5",
      x2: "210",
      y2: "64.5",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#D6E6FE" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#F4F7FF" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint4_linear_6346_14586",
      x1: "48",
      y1: "93.5",
      x2: "168",
      y2: "93.5",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#D6E6FE" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#FDECEB" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint5_linear_6346_14586",
      x1: "48",
      y1: "122.5",
      x2: "210",
      y2: "122.5",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#FBD0CD" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#FDECEB" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint6_linear_6346_14586",
      x1: "48",
      y1: "151.5",
      x2: "168",
      y2: "151.5",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#FBD0CD" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#FDECEB" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint7_linear_6346_14586",
      x1: "2.33543e-05",
      y1: "162",
      x2: "30",
      y2: "132",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#F69891" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#FDECEB" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint8_linear_6346_14586",
      x1: "15",
      y1: "124",
      x2: "15",
      y2: "0",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { offset: "0.298626", stopColor: "#F6F7F9" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#F6F7F9", stopOpacity: "0" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint9_linear_6346_14586",
      x1: "15",
      y1: "0",
      x2: "15",
      y2: "124",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#F69891" })
  ), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6346_14586" }, /* @__PURE__ */ React.createElement("rect", { width: "162", height: "162", fill: "white", transform: "translate(48)" })))
);
export {
  ErrorIcon
};
//# sourceMappingURL=error-icon.js.map
